import { FC, useState, useEffect } from 'react';
import styles from '../../ProductPage.module.scss';
import BackButton from '../../../../BackButton/BackButton';
import clsx from 'clsx';
import Print from '../../Print';
import List from '../List/List';
import Pagination from '../../../CatalogPage/components/Pagination/Pagination';
import { IItemProps } from '../List/List';
import Warning from './Warning';
import Compact from '../../../../Icons/Compact';
import Search from '../../../../Icons/Search';
import Cards from '../../../../Icons/Cards';
import { IGetPartResponse } from '../../../../../types/parts';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';
import { useTypedSelector } from '../../../../../lib/hooks/useTypedSelector';
import Cart from '../../Cart';
import Comment from '../../../../Icons/Comment';
import ModalAddToCart from '../../../../ModalAddToCart/ModalAddToCart';
import { numWord } from '../../../../../helpers/formatters';
import {
  pickReplacement,
  populatedReplacements,
} from '../../../../../helpers/replacements';
import { Link, useNavigate } from 'react-router-dom';
import StatusNew from '../../../../StatusNew/StatusNew';

import Favorites from '../../../../Icons/Favorites';
import {
  getFavorites,
  updateFavorites,
} from '../../../../../helpers/favorites';
import { ICardProps as IFavorites } from '../../../FavoritesPage/components/Card/Card';
import ModalComment from '../../../../ModalComment/ModalComment';

const Detail: FC<IGetPartResponse> = ({
  status,
  type,
  name,
  cmmf,
  replacedBy,
  replaceFor,
  brand,
  category,
  partCode,
  products,
  image,
  id,
  metaData,
  priceIndex,
}) => {
  const navigate = useNavigate();

  const [view, setView] = useState('compact');
  const [list, setList] = useState<IItemProps[]>([]);
  const [filteredList, setFilteredList] = useState<IItemProps[]>([]);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pages, setPages] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [remainder, setRemainder] = useState<number>(0);
  const count = 12;

  const updatePage = (page: number) => {
    if (!products) return;
    setList(filteredList.slice(limit * (page - 1), limit * page));
    setRemainder(
      filteredList.length - limit * page > 0
        ? filteredList.length - limit * page
        : 0,
    );
    setCurrentPage(page);
  };
  const updateLimit = (value: number) => {
    if (!products) return;
    setLimit(value);
    setPages(
      filteredList.length / value > 1
        ? Math.ceil(filteredList.length / value)
        : 1,
    );
    setList(filteredList.slice(0, value));
    setFilteredList(filteredList.slice(0, value));
    setCurrentPage(1);
  };
  const showMore = () => {
    if (!products) return;
    setList(filteredList.slice(0, limit * currentPage + count));
    setRemainder((state) => filteredList.length - list.length - state);
  };

  useEffect(() => {
    if (products) {
      setPages(
        products.length / limit > 1 ? Math.ceil(products.length / limit) : 1,
      );
      setList(products.slice(0, limit) || []);
      setFilteredList(products || []);
      setRemainder(products.length - limit > 0 ? products.length - limit : 0);
    }
  }, [products]);

  const searchFunc = (str: string) => {
    if (str !== '') {
      const arr =
        products?.filter((item) => {
          if (
            item.displayData.cmmf.toLowerCase().indexOf(str) !== -1 ||
            item.displayData.name.toLowerCase().indexOf(str) !== -1
          )
            return item;
        }) || [];
      setList(arr);
      setFilteredList(arr);
      setPages(arr.length / limit > 1 ? Math.ceil(arr.length / limit) : 1);
      setRemainder(arr.length - limit > 0 ? arr.length - limit : 0);
    } else {
      if (!products) return;
      setPages(
        products.length / limit > 1 ? Math.ceil(products.length / limit) : 1,
      );
      setList(products.slice(0, limit) || []);
      setFilteredList(products || []);
      setRemainder(products.length - limit > 0 ? products.length - limit : 0);
    }
  };

  const { cart } = useTypedSelector((state) => state);
  const indexInCart = cart.findIndex((item) => item.product_id === id);
  const [isModalActive, setModalActive] = useState(false);
  const handleModalOpen = () => {
    setModalActive(true);
  };
  const handleModalClose = () => {
    setModalActive(false);
  };

  const [commentVisible, setCommentVisible] = useState(false);
  const [isModalCommentActive, setModalCommentActive] = useState(false);
  const handleModalCommentOpen = () => {
    setModalCommentActive(true);
  };
  const handleModalCommentClose = () => {
    setModalCommentActive(false);
  };

  const [indexInfavorites, setIndexInFavorites] = useState<number>(-1);

  const updateFavoritesList = (data: IFavorites) => {
    if (indexInfavorites === -1) {
      updateFavorites(data, 'add').then(() => {
        setIndexInFavorites(1);
      });
    } else
      updateFavorites(data, 'delete').then(() => {
        setIndexInFavorites(-1);
      });
  };

  const filterReplacedBy = populatedReplacements<any>(replacedBy).filter(
    (item) => item.displayData.isActive,
  );

  const isReplacedByArray = filterReplacedBy.length > 0;

  const replacedByItem = pickReplacement<any>(filterReplacedBy);

  // Нераскрытые связи (голые id) показывать нечем — отбрасываем их здесь же.
  const filterReplaceFor = populatedReplacements<any>(replaceFor);

  const in_stoke = status !== 'discontinued';

  useEffect(() => {
    getFavorites().then((arr) =>
      setIndexInFavorites(arr.findIndex((item) => item.id === id)),
    );
    const resizeFunc = () => {
      if (window.innerWidth < 1024) setView('cards');
    };
    window.addEventListener('resize', resizeFunc);
    resizeFunc();
    return () => window.removeEventListener('resize', resizeFunc);
  }, []);

  return (
    <div className={styles.Detail}>
      <div className={styles.back_button_holder}>
        <BackButton />
      </div>
      <div className={styles.header}>
        <div className={styles.header_content}>
          <h1>
            {type === 'part' ? 'Запчасть' : 'Аксессуар'} {name}
          </h1>
        </div>
        <button
          className={styles.favorites_btn}
          onClick={(e) => {
            e.preventDefault();
            updateFavoritesList({
              status,
              type: type as 'product' | 'part' | 'accessory',
              name,
              cmmf,
              replaceBy: replacedBy,
              replaceFor,
              brand,
              category,
              image,
              id,
              article_number: '',
              commercial_number: cmmf,
            });
          }}
        >
          <Favorites active={indexInfavorites !== -1} />
          {indexInfavorites !== -1 ? 'В избранном' : 'В избранное'}
        </button>
      </div>
      <div className={styles.info_holder}>
        <div className={styles.wrapper}>
          <div className={styles.info}>
            <div className={styles.main}>
              <StatusNew status={status} count={metaData.count} />
              <div className={styles.content}>
                {cmmf && <span>Артикул: {cmmf}</span>}
                {brand && <span>Бренд: {brand.name}</span>}
                {category && <span>Категория: {category.name}</span>}
                {partCode && <span>Коммерческий код: {partCode}</span>}
                {priceIndex && <span>Индекс: {priceIndex}</span>}
              </div>
            </div>
            {(filterReplacedBy && filterReplacedBy.length) ||
            (replaceFor && replaceFor.length) ? (
              <div className={styles.analogue}>
                {isReplacedByArray ? (
                  <>
                    <div>
                      <span>Замена на:</span>
                    </div>
                    <div className={styles.analogue_value}>
                      {filterReplacedBy.map((item: any, id: number) => (
                        <Link
                          key={id}
                          to={'/product/' + item.id}
                          state={{
                            type: item.displayData.isExtra
                              ? 'accessory'
                              : 'part',
                          }}
                        >
                          {item.displayData.partCode}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : null}
                {filterReplaceFor.length ? (
                  <>
                    <div>
                      <span>Замена для:</span>
                    </div>
                    <div className={styles.analogue_value}>
                      {filterReplaceFor.map((item: any, id: number) => (
                        <Link
                          key={id}
                          to={'/product/' + item.id}
                          state={{
                            type: item.displayData.isExtra
                              ? 'accessory'
                              : 'part',
                          }}
                        >
                          {item.displayData.partCode}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
          </div>
          {(status === 'discontinued' || !status) && !replacedByItem ? (
            <div className={styles.cart_btn_holder}>
              <button className={clsx(styles.cart_btn)} disabled>
                Недоступно к заказу
              </button>
            </div>
          ) : !in_stoke ? (
            <div className={styles.cart_btn_holder}>
              <button className={clsx(styles.cart_btn)} disabled>
                Недоступно к заказу
              </button>
            </div>
          ) : (
            <div className={styles.cart_btn_holder}>
              {indexInCart === -1 ? (
                <button
                  className={clsx(styles.cart_btn, styles.active, {
                    [styles.replace]:
                      !metaData.count && isReplacedByArray && replacedByItem,
                  })}
                  onClick={(e) => {
                    e.preventDefault();
                    handleModalOpen();
                  }}
                >
                  В корзину
                  {!metaData.count && isReplacedByArray && replacedByItem ? (
                    <span>
                      В корзину будет добавлена замена{' '}
                      {replacedByItem.displayData.partCode}
                    </span>
                  ) : null}
                </button>
              ) : (
                <div className={styles.cart_holder}>
                  <button
                    className={clsx(styles.cart_btn)}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/cart');
                    }}
                  >
                    {cart[indexInCart].count} <Cart />
                  </button>
                  {cart[indexInCart].comment && (
                    <div
                      className={clsx(styles.comment, {
                        [styles.open]: commentVisible,
                      })}
                      onPointerEnter={() => setCommentVisible(true)}
                      onPointerLeave={() => setCommentVisible(false)}
                      onClick={() => handleModalCommentOpen()}
                    >
                      <Comment />
                      <p>{cart[indexInCart].comment}</p>
                    </div>
                  )}
                </div>
              )}
              {!metaData.count && isReplacedByArray && replacedByItem ? (
                <span className={styles.replaceByWarning}>
                  <Warning />В корзину будет добавлена замена{' '}
                  {replacedByItem.displayData.partCode}
                </span>
              ) : null}
            </div>
          )}
          {/* {isReplacedByArray && replacedBy[0] && !replacedByItem ? (
            <span className={styles.warning}>
              <Warning />
              Невозможно добавить запчасть {replacedBy[0].displayData.cmmf} в
              корзину. Запчасть недоступна{' '}
            </span>
          ) : null} */}
        </div>
        <div className={styles.image_holder}>
          <div
            className={clsx(styles.image, {
              [styles.opacity]: status === 'discontinued' || !status,
            })}
          >
            {image && (
              <img
                src={
                  image?.s3Key
                    ? generateImageUrl(image?.s3Key)
                    : '/images/placeholderImage.png'
                }
                alt="image"
              />
            )}
          </div>
        </div>
      </div>
      {products && products.length ? (
        <div className={styles.list_holder}>
          <div className={styles.title_holder}>
            <h3>Где используется</h3>
            <span>
              {filteredList.length}{' '}
              {numWord(filteredList.length, [
                'продукт',
                'продукта',
                'продуктов',
              ])}
            </span>
          </div>
          <div className={styles.controls}>
            <div className={styles.search_holder}>
              <input
                name="search"
                placeholder="Поиск по коду или названию"
                onInput={(e) =>
                  searchFunc((e.target as HTMLTextAreaElement).value)
                }
              />
              <Search />
            </div>

            <div className={styles.view_btns}>
              <button
                className={clsx({ [styles.active]: view === 'compact' })}
                onClick={() => setView('compact')}
              >
                <Compact />
              </button>
              <button
                className={clsx({ [styles.active]: view === 'cards' })}
                onClick={() => setView('cards')}
              >
                <Cards />
              </button>
            </div>
          </div>
          <span className={styles.count_mob}>
            {filteredList.length}{' '}
            {numWord(filteredList.length, ['продукт', 'продукта', 'продуктов'])}
          </span>

          <List list={list} view={view} type={'model'} />
          {pages > 1 && (
            <Pagination
              count={pages}
              currentPage={currentPage}
              updatePage={updatePage}
              updateLimit={updateLimit}
              limit={limit}
              remainder={remainder}
              showMore={showMore}
            />
          )}
        </div>
      ) : null}

      <div className={styles.download_catalog}>
        <span>Инструменты SEB для ремонта и сервисного обслуживания</span>
        <span>
          <Print />
          <a
            href="https://6e8ee6a6-c00b-40bb-a4ec-44a1c22bfeef.selstorage.ru/5aaa669e-9d46-4d24-a023-a3296c90bbb2.pdf"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            Каталог.pdf
          </a>{' '}
          (672 КБ)
        </span>
      </div>
      {isModalCommentActive && (
        <ModalComment
          onClose={handleModalCommentClose}
          comment={cart[indexInCart].comment || ''}
        />
      )}
      {isModalActive && (
        <ModalAddToCart
          onClose={handleModalClose}
          data={{
            available:
              !metaData.count && replacedByItem
                ? replacedByItem.metaData.count
                : metaData.count,
            product_id:
              !metaData.count && replacedByItem ? replacedByItem.id : id,
            name:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.name
                : name,
            status:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.status || ''
                : status || '',
            cmmf:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.cmmf
                : cmmf,
            article_number:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.partCode
                : partCode,
            type:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.type
                : type,
            image:
              !metaData.count && replacedByItem
                ? replacedByItem.displayData.image?.s3Key || ''
                : image?.s3Key || '',
            count: 1,
          }}
        />
      )}
    </div>
  );
};

export default Detail;
